import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=7d87ae32&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/side-bar/Search.vue
// module id = 901
// module chunks = 0